import { usePlatform } from "@portal/hooks/usePlatform";
import { useGlobalSearchDispatch } from "@portal/providers/GlobalSearchProvider";
import type { FC } from "react";
import { Button, Icon } from "../../primitives";

export const GlobalSearchButton: FC = () => {
	const { openGlobalSearch } = useGlobalSearchDispatch();
	const { isMac } = usePlatform();

	return (
		<Button
			variant="ghost"
			data-testid="global-search-button"
			className="group h-[34px] flex items-center gap-2 px-3 rounded-[4px] border border-bc-heavy hover:border-bc-heavier hover:outline hover:outline-[1px] hover:-outline-offset-[0.5px] hover:outline-bc-heavier cursor-pointer"
			onClick={() => openGlobalSearch("header_button")}
			leadingIcon={
				<Icon
					type="magnifying-glass"
					color="tertiary"
					size="mini"
					className="group-hover:text-primary"
				/>
			}
		>
			<span className="text-xs text-secondary whitespace-nowrap group-hover:text-primary">
				{`Search (${isMac ? "⌘" : "Ctrl+"}K)`}
			</span>
		</Button>
	);
};
